<template>
  <div class="fl-sym-mt-10 fl-sym-p-2">
    <div class="fl-sym-text-xxs fl-sym-text-primary">PET PROFILE</div>
    <div class="fl-sym-text-5xl fl-sym-font-bold">{{pet.name}}</div>
    <div class="fl-sym-text-light-grey fl-sym-text-lg fl-sym-mt-2">
      {{getAge(pet.date_of_birth)}} - {{pet.breed}}
    </div>

    <NameComponent/>
    <BreedComponent/>
    <WeightScale/>

    <button
        @click="takeMeToPetDashboard()"
      class="fl-sym-w-full fl-sym-relative fl-sym-border-2 fl-sym-border-intermediate fl-sym-text-dark-blue fl-sym-text-sm fl-sym-rounded-full fl-sym-p-4 fl-sym-font-semibold fl-sym-mb-3 fl-sym-mt-10 fl-sym-border-dark-blue"
    >
      Return to Dashboard
    </button>
    <button
      class=" fl-sym-w-full fl-sym-relative fl-sym-text-sm fl-sym-p-4 fl-sym-font-semibold fl-sym-mb-3 fl-sym-mt-5 remove-pet"
    >
      Remove Pet
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex"
import WeightScale from "@/pages/pet/create/Weight.vue"
import BreedComponent from "@/components/pet/BreedComponent.vue"
import NameComponent from "@/components/pet/NameComponent.vue"
import getAgeFromDOB from "../../../utils/getAgeFromDOB";

export default {
  components: {
    NameComponent,
    WeightScale,
    BreedComponent,
  },
  computed: {
    ...mapState({
      pet: (state) => state.pet.pet,
    }),
  },
  data() {
    return {
      options: [
        {
          name: "Dog",
        },
        {
          name: "Cat",
        },
      ],
    }
  },
  methods: {
    getAge(dob) {
      return getAgeFromDOB(dob)
    },
    takeMeToPetDashboard() {
      this.$router.push({ name: process.env.VUE_APP_RT_HOME }).catch(()=>{})
    }
  }
}
</script>

<style>
.swipe-text {
  font-size: 13px;
  line-height: 18px;
  z-index: 100;
  position: relative;
}
.remove-pet {
  color: #ff3a19;
  font-size: 15px;
  letter-spacing: 0.64px;
  line-height: 20px;
}
</style>